import { logAndToast } from './logAndToast';
import { type Ctx, type LogHelper, LogLevels } from '@types';
import { writeIntoLogs } from '@lib/logger/writeIntoLogs.ts';

export const logError: LogHelper = async (
  message: string,
  source: string,
  context?: Ctx,
  showToast = true,
  forceLog = false
): Promise<void> => {
  await logAndToast({
    message,
    source,
    context,
    toast: showToast,
    level: 'error',
    forceLog
  });
};

export async function writeErrorLog<T> (message: string, source: string, context: Record<string, T>): Promise<void> {
  await writeIntoLogs({
    message,
    level: LogLevels.ERROR,
    source,
    context
  });
}
